import FirebaseDoc from "@/model/FirebaseDoc"

export default class Project extends FirebaseDoc{
  url() {
    if(this.data) {
      return `/projects/${this.id}`
    }
    return false
  }
}